import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-setup/channel";

// tbl_rem_channel. Write calls and Send test are Super Admin only.
const apiReminderChannel = {
  create:      (payload)     => axiosClient.post(`${BASE}/create`, payload),
  update:      (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getAll:      (payload)     => axiosClient.post(`${BASE}/get-all`, payload),
  getById:     (id)          => axiosClient.get(`${BASE}/get-by-id/${id}`),
  delete:      (ids)         => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),
  // Channels the builder can send, with their default template / config schema and channel_fid when set up.
  getHandlers: ()            => axiosClient.get(`${BASE}/get-handlers`),
  // Sends a fixed test message on the channel to the logged-in Super Admin.
  testSend:    (id)          => axiosClient.post(`${BASE}/test-send/${id}`),
};

export default apiReminderChannel;
